import safegoldIcon from "../../images/sections/success-stories/project-icons/safegold.svg"
import superbetterIcon from "../../images/sections/success-stories/project-icons/superbetter.svg"
import fluentIcon from "../../images/sections/success-stories/project-icons/fluent.svg"
import compdIcon from "../../images/sections/success-stories/project-icons/compd.svg"
// import insummaryIcon from "../../images/sections/success-stories/project-icons/insummary.svg"
import squeezeeIcon from "../../images/sections/success-stories/project-icons/squeezee.svg"
import flexnestIcon from "../../images/sections/success-stories/project-icons/flexnest.svg"
import livetakeIcon from "../../images/sections/success-stories/project-icons/livetake.svg"
import owlProtocolIcon from "../../images/sections/success-stories/project-icons/owlProtocol.svg"
import debbieIcon from "../../images/sections/success-stories/project-icons/debbie.svg"
import diallIcon from "../../images/sections/success-stories/project-icons/diall.svg"
import stonovationIcon from "../../images/sections/success-stories/project-icons/stonovation.svg"
import pelt8Icon from "../../images/sections/success-stories/project-icons/pelt8.svg"
import trallicon from "../../images/sections/success-stories/project-icons/tralli.svg"
import chronoIcon from "../../images/sections/success-stories/project-icons/chrono.svg"
import cheekyIcon from "../../images/sections/success-stories/project-icons/cheekyLogo.svg"
import IvyLogo from "../../images/sections/success-stories/project-icons/ivyLogo.svg"

export const projectsData = [
  {
    icon: safegoldIcon,
    label: "SafeGold",
    id: "safe-gold",
    url: "/success-stories/safe-gold",
  },
  {
    icon: superbetterIcon,
    label: "SuperBetter",
    id: "superbetter",
    url: "/success-stories/superbetter",
  },
  {
    icon: fluentIcon,
    label: "Fluent",
    id: "fluent",
    url: "/success-stories/fluent",
  },
  {
    icon: compdIcon,
    label: "COMPD",
    id: "compd",
    url: "/success-stories/compd",
  },
  // {
  //   icon: insummaryIcon,
  //   label: "Insummary",
  //   id: "insummary-ai",
  //   url: "/success-stories/insummary-ai",
  // },
  {
    icon: flexnestIcon,
    label: "Flexnest",
    id: "flexnest",
    url: "/success-stories/flexnest",
  },
  {
    icon: livetakeIcon,
    label: "LiveTake",
    id: "livetake",
    url: "/success-stories/livetake",
  },
  {
    icon: owlProtocolIcon,
    label: "OWL Protocol",
    id: "owl-protocol",
    url: "/success-stories/owl-protocol",
  },
  {
    icon: debbieIcon,
    label: "Debbie",
    id: "debbie",
    url: "/success-stories/debbie",
  },
  {
    icon: diallIcon,
    label: "Diall",
    id: "diall",
    url: "/success-stories/diall",
    hasLongWidth: true,
  },
  {
    icon: stonovationIcon,
    label: "Stonovation",
    id: "stonovation",
    url: "/success-stories/stonovation",
    hasLongWidth: true,
  },
  {
    icon: pelt8Icon,
    label: "Pelt8",
    id: "pelt8",
    url: "/success-stories/pelt8",
    hasLongWidth: true,
  },
  // {
  //   icon: workReceiptIcon,
  //   label: "Wrk Receipts",
  //   id: "wrk-receipts",
  //   url: "/success-stories/wrk-receipts",
  //   hasLongWidth: true,
  // },
  {
    icon: chronoIcon,
    label: "Chrono",
    id: "chrono",
    url: "/success-stories/chrono",
    // hasLongWidth: true,
  },
  {
    icon: trallicon,
    label: "Tralli",
    id: "tralli",
    url: "/success-stories/tralli",
    hasLongWidth: true,
  },
  {
    icon: squeezeeIcon,
    label: "Squeezee",
    id: "squeezee",
    url: "/success-stories/squeezee",
    // hasLongWidth: true,
  },
  {
    icon: cheekyIcon,
    label: "Cheeky",
    id: "cheeky",
    url: "/success-stories/cheeky",
  },

  {
    icon: IvyLogo,
    label: "IVY",
    id: "ivy-level",
    url: "/success-stories/ivy-level",
  },
]
